import React from 'react';
import Component from '@vfuk/core-filter-list';
const FilterList = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default FilterList;
